import { withCompInfo } from '../../core/withCompInfo'
import { FlashComponentDefinition, FlashComponentProps, FlashComponentPropsCarmiData } from './types'
import { ImageProps } from '../..'

export const props = withCompInfo<FlashComponentProps, FlashComponentDefinition, FlashComponentPropsCarmiData>(
	['compData', 'compProps', 'topology'],
	({ compData, compProps, topology }, carmiProps) => {
		const { uri, placeHolderImage } = compData
		const { link } = carmiProps
		const placeholderImage: Partial<ImageProps> = { ...placeHolderImage }
		placeholderImage.displayMode = compProps.displayMode === 'stretch' ? 'fill' : 'fit'
		return {
			uri: uri ? `${topology.mediaRootUrl}media/${uri}` : undefined,
			placeholderImage,
			link,
		}
	}
)
